<rask-page pageTitle="{{ 'LAGERMAL_DETAIL_SOEK' | translate }}">
  <ng-container headerContent>
    <rask-hantera-lagermal-filter [resultRequest]="yearRequest" (resultRequestChanged)="requestChange($event)"></rask-hantera-lagermal-filter>
  </ng-container>
  @if (yearRequest) {
    <rask-hantera-lagermal-navigation [lagermalFilter]="yearRequest" [selectedView]="view" (yearChange)="yearChange($event)" (viewChange)="viewChange($event)"></rask-hantera-lagermal-navigation>
    <rask-hantera-lagermal-result #result [(lagermalFilter)]="yearRequest" [(selectedView)]="view"></rask-hantera-lagermal-result>
  }
  <ng-container footerContent>
    <rask-save-button (click)="result.save()" [disabled]="!result || !result.canSave()" placement="left"></rask-save-button>
  </ng-container>
</rask-page>
